import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCustomerAgingQuickInfo extends Layout {
    labelAvailableCredit: Label;
    labelAvailableCreditTotal: Label;
    labelCashReceipts: Label;
    labelCashReceiptsTotal: Label;
    labelMiscBillTotal: Label;
    labelMiscInvoices: Label;
    labelOrdersNotRated: Label;
    labelOrdersNotRatedAmount: Label;
    labelTotalPastDue: Label;
    labelTotalPastDueAmount: Label;
    labelUnbilledTotalAmount: Label;
    labelUninvoiced: Label;
    panelAgingAmounts: Panel;
    panelAvailableCredit: Panel;
    panelCashReceipts: Panel;
    panelMiscInvoices: Panel;
    panelOrdersNotRated: Panel;
    panelTotalPastDue: Panel;
    panelUnbilledTotal: Panel;
    sourceCustomerAging: DataSource;
}
